import { Popover, StyledDialog, TextButton, mediaMixin, token } from '@zillow/constellation';
import styled, { css } from 'styled-components';

export const StyledTextButton = styled(TextButton)`
  text-decoration: none !important;
`;

export const StyledPopover = styled(Popover)`
  > ${StyledDialog} {
    max-height: 100% !important;
  }
`;

export const StyledDivDataCount = styled.div`
  height: 30px;
  width: 25px;
  background-color: ${token('colors.green100')};
  color: ${token('colors.green500')};
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const StyledRedDotContainer = styled.div`
  position: relative;
  top: -5px;

  ${mediaMixin(
    'xl',
    css`
      margin-left: 4px;
    `,
  )}
`;
